import api from '@core/api/';
import { set, toggle } from '@core/store/utils';
import { i18n } from '@core/plugins/i18n/index';
import { dateFn } from '@theme/utils/datefns';

const state = {
  isLoading: false,
  data: []
};

const getters = {
  isLoading: state => state.isLoading,
  guarantees: state => (state.data && state.data.length > 0) ? state.data.map((o) => {
    const parts = [];
    if(typeof(o.guarantee_number) !== 'undefined') parts.push(`${i18n.t('numbers.guarantee_number')}: ${ o.guarantee_number }`);
    if(typeof(o.reference_number) !== 'undefined') parts.push(`${i18n.t('numbers.reference_number')}: ${ o.reference_number }`);
    if(typeof(o.company_name) !== 'undefined') parts.push(`${i18n.t('label.company_name')}: ${ o.company_name }`);
    if(typeof(o.amount) !== 'undefined') parts.push(`${i18n.t('label.amount')}: ${ o.amount }`);
    if(typeof(o.created_at) !== 'undefined') parts.push(`${i18n.t('label.created_at')}: ${ dateFn(o.created_at) }`);
    const label = parts.join(', ');

    return {
      label: label,
      value: label,
      id: o.id
    };
  }) : [],
  activeTemplate: (state, getters) => (id) => getters.guarantees.find(o => o.id === id) || {}
};

const actions = {
  /**
  * send query to API
  * @method sendQuery
  */
  sendQuery({ commit }, searchQuery) {
    if(searchQuery.length < 3) return;

    commit('toggleLoading');

    const requestBody = {
      params: {
        autocomplete: true,
        'filter[search]': searchQuery,
      }
    };

    api.getApiData('guarantees', requestBody).then(({ data: responseData }) => {
      if (responseData && responseData.data) {
        commit('setData', responseData.data);
      }

      commit('toggleLoading');
    }).catch((error) => {
      api.apiError(error);
      commit('toggleLoading');
    });
  }
};

const mutations = {
  setData: set('data'),
  toggleLoading: toggle('isLoading')
};

export default {
  namespaced: true,

  state,
  getters,
  actions,
  mutations
};
